<div class="bl-check-wrap bl-margin-top--16 bl-margin-bottom--16" [class.bl-disabled]="!enabled">
  <input
    class="bl-display--inline-block"
    type="checkbox"
    [disabled]="!enabled"
    [id]="fieldId"
    name="{{ fieldId }}"
    [attr.data-automation-id]="consentField?.automationId"
    [(ngModel)]="value"
    #fieldValue="ngModel"
    [required]="required"
    (change)="onChangeConsentSelection(value)"
    (click)="enableClickEvent ?? onClickConsentCheckBox($event)"
    aria-describedby="consent-validation"
  />
  <label class="bl-text-style--default-text-1" [for]="fieldId">
    @for (item of checkboxData; track $index) { @if (item.data?.url) {
      <!-- IMPORTANT: keep on single line - do not auto-format this, whitespace is added when auto-formatted, and this leads to a trailing underline issue -->
    <a [href]="item.data.url" target="_blank" (click)="openSlideInPanel(item.data)" rel="noopener noreferrer" class="bl-margin-right--4 bl-padding-right--0">{{item.display}}</a>
    } @else if (item.data) {
      <!-- IMPORTANT: keep on single line - do not auto-format this, whitespace is added when auto-formatted, and this leads to a trailing underline issue -->
    <a href="javascript:void(0)" (click)="openSlideInPanel(item.data)" class="bl-margin-right--4 bl-padding-right--0">{{item.display}}</a>
    } @else {
    {{item.display}}
    } } @if (required) {
    <span class="bl-font-color--error">*</span>
    }
  </label>
  <div role="alert" id="consent-validation">
    @if ((isSubmitted || fieldValue.touched) && fieldValue.errors?.required && consentField?.config?.payload?.consentType !== 'tcpa') {
    <span class="bl-error-msg bl-margin-top--8">
      {{ 'consent/requiredErrorMessage' | dictionary }}
    </span>
    } @if (showViewRequiredMsg) {
    <span class="bl-error-msg bl-margin-top--8">
      {{ 'econsent/viewRequiredValidationMessage' | dictionary }}
    </span>
    }
  </div>
</div>

<ea-slide-in-panel
  [(isSlidePanelVisible)]="showPanel"
  [slidePanelTitle]="panelTitle"
  [fixedLayout]="true"
  openPanelElementId="open-disclosure-panel"
>
  <div *ngIf="showPanel" class="bl-border bl-border-radius bl-bg-color--white bl-padding-x--16 bl-padding-y--24 bl-padding-md--32">
    <!-- Consent -->
    <ng-container *ngIf="isDataloaded">
      <div class="bl-display--flex bl-justify-content--flex-end bl-margin-bottom--16 bl-height--100">
        <button
          *ngIf="isTextConsent"
          (click)="printTextConsent()"
          id="printtext-"
          type="button"
          class="bl-button bl-button-tertiary bl-padding-x--8 bl-padding-top--0 bl-print-hide"
        >
          {{ 'action/print' | dictionary }}
        </button>

        <button *ngIf="isDataloaded && pdfURL" (click)="printPDF()" id="printPDF-consent" class="bl-padding-right--24 bl-font-color--steel">
          <i class="cu-print bl-padding-right--8 bl-font-color--primary" alt="" aria-hidden="true"></i>
          <span>{{ 'disclosureReview/print' | dictionary }}</span>
        </button>
      </div>
      <div class="bl-padding--16 bl-position--relative" *ngIf="isDataloaded && pdfURL">
        <ecp-pdf-embed [pdfSrc]="pdfURL"></ecp-pdf-embed>
      </div>

      <div *ngIf="isTextConsent">
        <p [innerHTML]="panelContent | safe : 'html'"></p>
      </div>
    </ng-container>

    <!-- Loader -->
    <ng-container *ngIf="showPanel && !isDataloaded">
      <div class="bl-padding--16 bl-position--relative">
        <p class="bl-margin-y--24 bl-font-color--steel" [innerHTML]="'consent/loadingText' | dictionary"></p>
        <ecp-content-spinner [spinnerSmall]="true"></ecp-content-spinner>
      </div>
    </ng-container>
  </div>
</ea-slide-in-panel>
